import { EditorConfig } from "ckeditor5";
import { css, FlattenSimpleInterpolation } from "styled-components";

import { CLASS_PREFIX } from "./utils";

export const buildEditorStyles = (
  config: EditorConfig,
): FlattenSimpleInterpolation | undefined => {
  if (config.markBlocks == null) return;

  return css`
    .ck.ck-content {
      ${Object.entries(config.markBlocks).map(
        ([name, config]) => css`
          .${CLASS_PREFIX}-${name} {
            border: var(--rce-widget-border);
            border-radius: var(--ck-border-radius);
            padding: 0.5rem;
            position: relative;

            ${config.readonly &&
            css`
              max-height: 1.5rem;
              overflow: hidden;
            `}

            &::before {
              content: "${config.showLabel || config.readonly
                ? config.label
                : ""}";
              ${config.readonly
                ? css`
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    box-sizing: border-box;
                    backdrop-filter: blur(1px);
                  `
                : css`
                    float: right;
                    position: relative;
                    top: -0.5rem;
                    right: -0.5rem;
                    height: 1.5rem;
                    line-height: 1.5rem;
                  `}

              text-align: right;
              border-radius: 4px;
              padding: 0.5rem 1rem;
              background-color: var(--rce-color-widget-background);
              z-index: 100;

              ${config.icon != null &&
              css`
                background-image: url(data:image/svg+xml, ${encodeURIComponent(
                  config.icon,
                )});
                background-size: 20px;
                background-repeat: no-repeat;
                background-position-x: 0.5rem;
                background-position-y: center;
                padding-left: ${config.showLabel || config.readonly
                  ? "calc(20px + 1rem)"
                  : "20px"};
              `}
            }
          }
        `,
      )}
    }
  `;
};
